import React, { useCallback, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import moment from 'moment';
import HeaderStrip from '../../../components/Common/HeaderStrip';
import Pagination from '../../../components/Common/Pagination';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';

const Project = () => {

    const [dataStatus, setStatus] = useState("ongoing");
    const [projectSearchValue, setProjectSearchValue] = useState("");
    const [filterDate, setFilterDate] = useState([]);
    const [selectDate, setSelectDate] = useState("all");
    const [projectListData, setProjectListData] = useState([]);
    const [searchData, setSearchData] = useState();
    const [loading, setLoading] = useState(false);
    const [currentPage, setCurrentPage] = useState(0);
    const [screenWidth, setScreenWidth] = useState(window.innerWidth);
    const dispatch = useDispatch();
    const projectsData = useSelector(state => state.projects.projects)
    const projectsTotal = useSelector(state => state.projects.projectsTotal)
    const pageLimit = 10;
    const pageCount = (Math.ceil(projectsTotal / pageLimit));

    const headerTitle = [
        {
            id: '1',
            label: 'Projects',
            classwidth: '1/3',

        },
        {
            id: '2',
            label: 'Type',
            classwidth: '1/4',
        },
        {
            id: '3',
            label: 'Technology',
            classwidth: '1/2',

        },

        {
            id: '4',
            label: 'Client',
            classwidth: '1/3',
        },
        {
            id: '5',
            label: 'Start Date - End Date',
            classwidth: '1/2',
        },
        {
            id: '6',
            label: 'Action',
            classwidth: '1/5',
            center: 'text-center'

        },
    ]

    useEffect(() => {

        const handleResize = () => {
            setScreenWidth(window.innerWidth);
        };

        window.addEventListener('resize', handleResize);

        //cleanup function
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    const getListData = async () => {
        setLoading(true);
        setCurrentPage(0);
        await dispatch.projects.listProjectData({
            limit: pageLimit,
            currentPage: 0,
            status: dataStatus,
            search: projectSearchValue
        });
        setLoading(false);
    }

    useEffect(() => {
        getListData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dataStatus]);

    function getStatusClass(status) {
        let statusClass = '';
        switch (status) {
            case 'ongoing':
                statusClass = 'bg-primary-600';
                break;
            case 'hold':
                statusClass = 'bg-warning';
                break;
            case 'complete':
                statusClass = 'bg-success';
                break;
            default:
                statusClass = '';
        }
        return statusClass;
    }

    const getStatus = useCallback((selectedStatus) => {
        setStatus(selectedStatus);
    }, []);


    const handleChange = useCallback((e) => {
        setSelectDate(e.target.value)
    }, []);


    useEffect(() => {

        if (projectsData.data) {
            const projects = projectsData.data;
            setProjectListData(projects);
            const sortedUniqueList = Array.from(new Set(projects?.map(a => moment(a.start_date).format('YYYY')))).map(date => { return projects?.find(a => moment(a.start_date).format('YYYY') === date) })
            setFilterDate(sortedUniqueList);
        }

        return () => {
            setProjectListData([])
        }

    }, [projectsData]);


    useEffect(() => {

        if (projectsData.data) {
            const projects = projectsData.data;
            setProjectListData(projects);
        }

        return () => {
            setProjectListData([])
        }

    }, [selectDate, searchData, projectsData.data]);



    const searchSelect = (searchData) => {
        setSearchData(searchData && searchData.value)
    }

    // For Pagination
    const handlePageClick = useCallback(async (event) => {
        setLoading(true);
        setCurrentPage(event.selected);
        await dispatch.projects.listProjectData({
            limit: pageLimit,
            currentPage: event.selected,
            status: dataStatus,
            search: projectSearchValue
        });

        setLoading(false);
    }, [dataStatus]);


    const projectSearch = async (searchvalue) => {
        setProjectSearchValue(searchvalue);
        setLoading(true);
        setCurrentPage(0);
        await dispatch.projects.listProjectData({
            limit: pageLimit,
            currentPage: 0,
            status: dataStatus,
            search: searchvalue

        });
        setLoading(false);
    }

    return (
        <>
            <div className="px-6 max-w-full overflow-x-auto pt-6 pb-7">
                <div className="grid sm:grid-cols-4 gap-4">
                    <div className="border border-borderColor-100 rounded-md block sm:flex sm:justify-center md:block relative p-5 text-left project-item-block all-projects">

                        <div className="inline-flex sm:hidden md:inline-flex">

                            <div className="icon">
                                <svg width="34" height="40" viewBox="0 0 34 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path fillRule="evenodd" clipRule="evenodd" d="M12.752 38.1341C12.752 37.352 13.386 36.718 14.1681 36.718H19.8327C20.6148 36.718 21.2488 37.352 21.2488 38.1341C21.2488 38.9162 20.6148 39.5503 19.8327 39.5503H14.1681C13.386 39.5503 12.752 38.9162 12.752 38.1341Z" fill="white" />
                                    <path fillRule="evenodd" clipRule="evenodd" d="M15.2206 0.889179C15.7215 0.476096 16.3506 0.25 17.0002 0.25C17.6521 0.25 18.2833 0.477678 18.785 0.893515C20.5434 2.32551 24.35 5.87561 26.4559 11.3496C28.5924 16.903 28.918 24.2885 23.8975 33.1666C23.6462 33.611 23.1752 33.8857 22.6648 33.8857H11.3356C10.8295 33.8857 10.3619 33.6156 10.109 33.1772C4.98582 24.2971 5.29955 16.9007 7.4599 11.3387C9.58645 5.86371 13.4412 2.31446 15.2206 0.889179ZM17.0002 3.09264C17 3.09275 16.9999 3.09285 16.9998 3.09296C15.4115 4.36356 11.9746 7.53799 10.1 12.3642C8.30912 16.975 7.88522 23.2355 12.164 31.0534H21.8281C26.0164 23.2384 25.5871 16.9793 23.8125 12.3666C21.959 7.54871 18.5762 4.37677 17.0002 3.09264Z" fill="white" />
                                    <path fillRule="nodd" clipRule="evenodd" d="M8.3311 17.115C8.93141 17.6163 9.01165 18.5094 8.51033 19.1097L2.9636 25.7516C2.96394 25.7531 2.96428 25.7546 2.96461 25.7562L5.14095 35.6116L10.4508 31.3637C11.0615 30.8752 11.9527 30.9742 12.4413 31.5849C12.9299 32.1956 12.8308 33.0868 12.2201 33.5754L6.90891 37.8243C6.53362 38.1242 6.08823 38.3237 5.61463 38.404C5.14102 38.4844 4.65476 38.4429 4.20158 38.2836C3.74841 38.1243 3.34319 37.8523 3.02405 37.4933C2.70492 37.1342 2.48234 36.6999 2.37726 36.2312L2.37628 36.2268L0.202614 26.3834C0.100597 25.9623 0.0991026 25.5229 0.198408 25.1008C0.298747 24.6744 0.499091 24.278 0.782831 23.9444L6.33641 17.2942C6.83773 16.6939 7.73078 16.6137 8.3311 17.115Z" fill="white" />
                                    <path fillRule="evenodd" clipRule="evenodd" d="M25.5635 16.9724C26.1644 16.4717 27.0573 16.5529 27.558 17.1538L33.2174 23.945C33.5009 24.2786 33.701 24.6747 33.8013 25.1009C33.9006 25.5229 33.8991 25.9623 33.7971 26.3835L31.6234 36.2268L31.6224 36.2312C31.5174 36.6999 31.2948 37.1342 30.9756 37.4933C30.6565 37.8523 30.2513 38.1243 29.7981 38.2836C29.3449 38.4429 28.8587 38.4844 28.3851 38.404C27.9115 38.3237 27.4661 38.1242 27.0908 37.8244L21.7796 33.5754C21.1689 33.0868 21.0698 32.1956 21.5584 31.5849C22.047 30.9742 22.9382 30.8752 23.5489 31.3638L28.8588 35.6116L31.0351 25.7562C31.0354 25.7547 31.0358 25.7531 31.0361 25.7516L25.3822 18.9669C24.8815 18.3661 24.9627 17.4731 25.5635 16.9724Z" fill="white" />
                                    <path d="M17.0002 17.6001C18.1734 17.6001 19.1244 16.6491 19.1244 15.4759C19.1244 14.3027 18.1734 13.3517 17.0002 13.3517C15.827 13.3517 14.876 14.3027 14.876 15.4759C14.876 16.6491 15.827 17.6001 17.0002 17.6001Z" fill="white" />
                                </svg>
                            </div>

                            <div className="pl-4">
                                <h5 className="mb-1">Total Projects</h5>
                                <h2 className="text-white">{projectsData && projectsData.count && projectsData.count.totalcount}</h2>
                            </div>

                        </div>

                        <div className="hidden sm:flex sm:flex-col md:hidden justify-center items-center">
                            <h5 className="mb-1">Total Projects</h5>
                            <h2 className="text-white">{projectsData && projectsData.count && projectsData.count.totalcount}</h2>
                        </div>

                        <div className="block sm:hidden md:block absolute right-5 bottom-5 mb-2 cursor-pointer">
                            <svg width="21" height="16" viewBox="0 0 21 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <g opacity="0.6">
                                    <path d="M18 8H1" stroke="white" strokeWidth="2" strokeLinecap="round" />
                                    <path d="M13.2549 1.81543L19.0784 8.02495L13.2549 14.2345" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                </g>
                            </svg>
                        </div>

                    </div>

                    <div className="border border-borderColor-100 rounded-md block sm:flex sm:justify-center md:block relative p-5 text-left project-item-block  active-projects">
                        <div className="inline-flex sm:hidden md:inline-flex">

                            <div className="icon">
                                <svg width="38" height="31" viewBox="0 0 38 31" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path fillRule="evenodd" clipRule="evenodd" d="M33.2878 19.8571C32.8021 19.8571 32.4306 19.4857 32.4306 19V4.71429C32.4306 3.6 31.5449 2.71429 30.4306 2.71429H7.57349C6.45921 2.71429 5.57349 3.6 5.57349 4.71429V19C5.57349 19.4857 5.20206 19.8571 4.71635 19.8571C4.23064 19.8571 3.85921 19.4857 3.85921 19V4.71429C3.85921 2.65714 5.51635 1 7.57349 1H30.4306C32.4878 1 34.1449 2.65714 34.1449 4.71429V19C34.1449 19.4857 33.7735 19.8571 33.2878 19.8571ZM7.57143 29.5714C3.94286 29.5714 1 26.6286 1 23C1 22.5143 1.37143 22.1429 1.85714 22.1429H36.1429C36.6286 22.1429 37 22.5143 37 23C37 26.6286 34.0571 29.5714 30.4286 29.5714H7.57143ZM2.8 23.8572C3.2 26.1143 5.2 27.8572 7.57143 27.8572H19H30.4286C32.8286 27.8572 34.8 26.1143 35.2 23.8572H2.8ZM15.287 10.7144C15.287 11.2001 15.6584 11.5715 16.1441 11.5715C16.6299 11.5715 17.0013 11.2001 17.0013 10.7144V7.85725C17.0013 7.37154 16.6299 7.00011 16.1441 7.00011C15.6584 7.00011 15.287 7.37154 15.287 7.85725V10.7144ZM21.858 11.5715C21.3723 11.5715 21.0009 11.2001 21.0009 10.7144V7.85725C21.0009 7.37154 21.3723 7.00011 21.858 7.00011C22.3438 7.00011 22.7152 7.37154 22.7152 7.85725V10.7144C22.7152 11.2001 22.3438 11.5715 21.858 11.5715ZM12.1408 15.5714C14.0266 17.4572 16.5123 18.4 18.998 18.4C21.4837 18.4 23.9694 17.4572 25.8266 15.5714C26.1694 15.2572 26.1694 14.7143 25.8266 14.3714C25.5123 14.0286 24.9694 14.0286 24.6266 14.3714C21.5123 17.4857 16.4551 17.4857 13.3408 14.3714L13.2551 14.2857C12.9408 13.9429 12.398 13.9429 12.0551 14.2857C11.7123 14.6 11.7123 15.1429 12.0551 15.4857L12.1408 15.5714Z" fill="white" />
                                    <path d="M2.8 23.8572V23.1072H1.9054L2.06151 23.988L2.8 23.8572ZM35.2 23.8572L35.9385 23.988L36.0946 23.1072H35.2V23.8572ZM12.1408 15.5714L12.6712 15.0411L12.6712 15.0411L12.1408 15.5714ZM25.8266 15.5714L25.3198 15.0186L25.3056 15.0315L25.2922 15.0452L25.8266 15.5714ZM25.8266 14.3714L25.2737 14.8782L25.2847 14.8903L25.2962 14.9018L25.8266 14.3714ZM24.6266 14.3714L24.0962 13.8411L24.0962 13.8411L24.6266 14.3714ZM13.3408 14.3714L13.8712 13.8411L13.8712 13.8411L13.3408 14.3714ZM13.2551 14.2857L12.7023 14.7925L12.7133 14.8045L12.7248 14.8161L13.2551 14.2857ZM12.0551 14.2857L12.5619 14.8386L12.5739 14.8276L12.5855 14.8161L12.0551 14.2857ZM12.0551 15.4857L11.5248 16.0161L11.5248 16.0161L12.0551 15.4857ZM31.6806 19C31.6806 19.8999 32.3879 20.6071 33.2878 20.6071V19.1071C33.2411 19.1071 33.2184 19.0914 33.2074 19.0804C33.1964 19.0694 33.1806 19.0467 33.1806 19H31.6806ZM31.6806 4.71429V19H33.1806V4.71429H31.6806ZM30.4306 3.46429C31.1307 3.46429 31.6806 4.01421 31.6806 4.71429H33.1806C33.1806 3.18579 31.9591 1.96429 30.4306 1.96429V3.46429ZM7.57349 3.46429H30.4306V1.96429H7.57349V3.46429ZM6.32349 4.71429C6.32349 4.01421 6.87342 3.46429 7.57349 3.46429V1.96429C6.04499 1.96429 4.82349 3.18579 4.82349 4.71429H6.32349ZM6.32349 19V4.71429H4.82349V19H6.32349ZM4.71635 20.6071C5.61628 20.6071 6.32349 19.8999 6.32349 19H4.82349C4.82349 19.0467 4.80773 19.0694 4.79673 19.0804C4.78574 19.0914 4.76304 19.1071 4.71635 19.1071V20.6071ZM3.10921 19C3.10921 19.8999 3.81642 20.6071 4.71635 20.6071V19.1071C4.66966 19.1071 4.64696 19.0914 4.63597 19.0804C4.62498 19.0694 4.60921 19.0467 4.60921 19H3.10921ZM3.10921 4.71429V19H4.60921V4.71429H3.10921ZM7.57349 0.25C5.10214 0.25 3.10921 2.24293 3.10921 4.71429H4.60921C4.60921 3.07136 5.93056 1.75 7.57349 1.75V0.25ZM30.4306 0.25H7.57349V1.75H30.4306V0.25ZM34.8949 4.71429C34.8949 2.24293 32.902 0.25 30.4306 0.25V1.75C32.0736 1.75 33.3949 3.07136 33.3949 4.71429H34.8949ZM34.8949 19V4.71429H33.3949V19H34.8949ZM33.2878 20.6071C34.1877 20.6071 34.8949 19.8999 34.8949 19H33.3949C33.3949 19.0467 33.3792 19.0694 33.3682 19.0804C33.3572 19.0914 33.3345 19.1071 33.2878 19.1071V20.6071ZM0.25 23C0.25 27.0428 3.52864 30.3214 7.57143 30.3214V28.8214C4.35707 28.8214 1.75 26.2144 1.75 23H0.25ZM1.85714 21.3929C0.957216 21.3929 0.25 22.1001 0.25 23H1.75C1.75 22.9533 1.76577 22.9306 1.77676 22.9196C1.78775 22.9086 1.81045 22.8929 1.85714 22.8929V21.3929ZM36.1429 21.3929H1.85714V22.8929H36.1429V21.3929ZM37.75 23C37.75 22.1001 37.0428 21.3929 36.1429 21.3929V22.8929C36.1895 22.8929 36.2123 22.9086 36.2232 22.9196C36.2342 22.9306 36.25 22.9533 36.25 23H37.75ZM30.4286 30.3214C34.4714 30.3214 37.75 27.0428 37.75 23H36.25C36.25 26.2144 33.6429 28.8214 30.4286 28.8214V30.3214ZM7.57143 30.3214H30.4286V28.8214H7.57143V30.3214ZM7.57143 27.1072C5.57113 27.1072 3.87632 25.6326 3.53849 23.7263L2.06151 23.988C2.52368 26.596 4.82887 28.6072 7.57143 28.6072V27.1072ZM19 27.1072H7.57143V28.6072H19V27.1072ZM30.4286 27.1072H19V28.6072H30.4286V27.1072ZM34.4615 23.7263C34.1232 25.6353 32.4547 27.1072 30.4286 27.1072V28.6072C33.2024 28.6072 35.4768 26.5933 35.9385 23.988L34.4615 23.7263ZM2.8 24.6072H35.2V23.1072H2.8V24.6072ZM16.1441 10.8215C16.0975 10.8215 16.0747 10.8058 16.0638 10.7948C16.0528 10.7838 16.037 10.7611 16.037 10.7144H14.537C14.537 11.6143 15.2442 12.3215 16.1441 12.3215V10.8215ZM16.2513 10.7144C16.2513 10.7611 16.2355 10.7838 16.2245 10.7948C16.2135 10.8058 16.1908 10.8215 16.1441 10.8215V12.3215C17.0441 12.3215 17.7513 11.6143 17.7513 10.7144H16.2513ZM16.2513 7.85725V10.7144H17.7513V7.85725H16.2513ZM16.1441 7.75011C16.1908 7.75011 16.2135 7.76588 16.2245 7.77687C16.2355 7.78786 16.2513 7.81056 16.2513 7.85725H17.7513C17.7513 6.95733 17.0441 6.25011 16.1441 6.25011V7.75011ZM16.037 7.85725C16.037 7.81057 16.0528 7.78786 16.0638 7.77687C16.0747 7.76588 16.0975 7.75011 16.1441 7.75011V6.25011C15.2442 6.25011 14.537 6.95733 14.537 7.85725H16.037ZM16.037 10.7144V7.85725H14.537V10.7144H16.037ZM20.2509 10.7144C20.2509 11.6143 20.9581 12.3215 21.858 12.3215V10.8215C21.8113 10.8215 21.7886 10.8058 21.7777 10.7948C21.7667 10.7838 21.7509 10.7611 21.7509 10.7144H20.2509ZM20.2509 7.85725V10.7144H21.7509V7.85725H20.2509ZM21.858 6.25011C20.9581 6.25011 20.2509 6.95733 20.2509 7.85725H21.7509C21.7509 7.81057 21.7667 7.78786 21.7777 7.77687C21.7886 7.76588 21.8113 7.75011 21.858 7.75011V6.25011ZM23.4652 7.85725C23.4652 6.95733 22.758 6.25011 21.858 6.25011V7.75011C21.9047 7.75011 21.9274 7.76588 21.9384 7.77687C21.9494 7.78786 21.9652 7.81057 21.9652 7.85725H23.4652ZM23.4652 10.7144V7.85725H21.9652V10.7144H23.4652ZM21.858 12.3215C22.758 12.3215 23.4652 11.6143 23.4652 10.7144H21.9652C21.9652 10.7611 21.9494 10.7838 21.9384 10.7948C21.9274 10.8058 21.9047 10.8215 21.858 10.8215V12.3215ZM18.998 17.65C16.7013 17.65 14.4094 16.7793 12.6712 15.0411L11.6105 16.1018C13.6437 18.135 16.3232 19.15 18.998 19.15V17.65ZM25.2922 15.0452C23.5849 16.7788 21.2958 17.65 18.998 17.65V19.15C21.6716 19.15 24.354 18.1355 26.3609 16.0977L25.2922 15.0452ZM25.2962 14.9018C25.3256 14.9311 25.3337 14.9612 25.3337 14.9822C25.3337 15.0021 25.3274 15.0116 25.3198 15.0186L26.3334 16.1243C27.0139 15.5005 26.9792 14.4635 26.3569 13.8411L25.2962 14.9018ZM25.1569 14.9018C25.1862 14.8724 25.2163 14.8643 25.2373 14.8643C25.2572 14.8643 25.2667 14.8706 25.2737 14.8782L26.3794 13.8647C25.7556 13.1841 24.7186 13.2188 24.0962 13.8411L25.1569 14.9018ZM12.8105 14.9018C16.2177 18.309 21.7497 18.309 25.1569 14.9018L24.0962 13.8411C21.2748 16.6625 16.6926 16.6625 13.8712 13.8411L12.8105 14.9018ZM12.7248 14.8161L12.8105 14.9018L13.8712 13.8411L13.7855 13.7554L12.7248 14.8161ZM12.5855 14.8161C12.6148 14.7867 12.6449 14.7786 12.6658 14.7786C12.6858 14.7786 12.6953 14.7849 12.7023 14.7925L13.808 13.7789C13.1842 13.0984 12.1472 13.1331 11.5248 13.7554L12.5855 14.8161ZM12.5855 14.9554C12.5561 14.9261 12.548 14.896 12.548 14.875C12.548 14.8551 12.5543 14.8456 12.5619 14.8386L11.5483 13.7329C10.8678 14.3567 10.9025 15.3937 11.5248 16.0161L12.5855 14.9554ZM12.6712 15.0411L12.5855 14.9554L11.5248 16.0161L11.6105 16.1018L12.6712 15.0411Z" fill="white" />
                                </svg>
                            </div>

                            <div className="pl-4">
                                <h5 className="mb-1">Active Projects</h5>
                                <h2 className="text-white">{projectsData && projectsData.count && projectsData.count.ongoingcount}</h2>
                            </div>

                        </div>
                        <div className="hidden sm:flex sm:flex-col md:hidden justify-center items-center">
                            <h5 className="mb-1">Active Projects</h5>
                            <h2 className="text-white">{projectsData && projectsData.count && projectsData.count.ongoingcount}</h2>
                        </div>

                        <div className="block sm:hidden md:block absolute right-5 bottom-5 mb-2 cursor-pointer">

                            <svg width="21" height="16" viewBox="0 0 21 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <g opacity="0.6">
                                    <path d="M18 8H1" stroke="white" strokeWidth="2" strokeLinecap="round" />
                                    <path d="M13.2549 1.81543L19.0784 8.02495L13.2549 14.2345" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                </g>
                            </svg>
                        </div>

                    </div>

                    <div className="border border-borderColor-100 rounded-md block sm:flex sm:justify-center md:block  relative p-5 text-left project-item-block  hold-projects">
                        <div className="inline-flex sm:hidden md:inline-flex">

                            <div className="icon">
                                <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M17 1C8.16333 1 1 8.16333 1 17C1 25.8367 8.16333 33 17 33C25.8367 33 33 25.8367 33 17C33 8.16333 25.8367 1 17 1ZM3.66667 17C3.66667 9.636 9.636 3.66667 17 3.66667C20.2327 3.66667 23.1953 4.818 25.5033 6.73133L6.73133 25.5033C4.818 23.1953 3.66667 20.2327 3.66667 17ZM17 30.3333C13.8293 30.3333 10.9207 29.222 8.632 27.374L27.3733 8.63267C29.222 10.9207 30.3333 13.8293 30.3333 17C30.3333 24.364 24.364 30.3333 17 30.3333Z" fill="white" stroke="white" />
                                </svg>
                            </div>

                            <div className="pl-4">
                                <h5 className="mb-1">Hold Projects</h5>
                                <h2 className="text-white">{projectsData && projectsData.count && projectsData.count.holdcount}</h2>
                            </div>

                        </div>

                        <div className="hidden sm:flex sm:flex-col md:hidden justify-center items-center">
                            <h5 className="mb-1">Hold Projects</h5>
                            <h2 className="text-white">{projectsData && projectsData.count && projectsData.count.holdcount}</h2>
                        </div>

                        <div className="block sm:hidden md:block absolute right-5 bottom-5 mb-2 cursor-pointer">

                            <svg width="21" height="16" viewBox="0 0 21 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <g opacity="0.6">
                                    <path d="M18 8H1" stroke="white" strokeWidth="2" strokeLinecap="round" />
                                    <path d="M13.2549 1.81543L19.0784 8.02495L13.2549 14.2345" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                </g>
                            </svg>
                        </div>

                    </div>


                    <div className="border border-borderColor-100 rounded-md block sm:flex sm:justify-center md:block relative p-5 text-left project-item-block completed-projects">
                        <div className="inline-flex sm:hidden md:inline-flex">

                            <div className="icon">
                                <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M11.9113 22.4C12.2669 22.9333 12.8002 23.1111 13.3336 23.1111C13.8669 23.1111 14.4002 22.9333 14.7558 22.4L22.7558 11.7333C23.2891 11.0222 23.1113 9.77778 22.4002 9.24445C21.6891 8.71111 20.4447 8.88889 19.9113 9.6L13.3336 18.3111L12.0891 16.7111C11.5558 16 10.3113 15.8222 9.60023 16.3556C8.88912 16.8889 8.71134 18.1333 9.24467 18.8444L11.9113 22.4Z" fill="white" />
                                    <path d="M16 32C24.8889 32 32 24.8889 32 16C32 7.11111 24.8889 0 16 0C7.11111 0 0 7.11111 0 16C0 24.8889 7.11111 32 16 32ZM16 3.55556C22.9333 3.55556 28.4444 9.06667 28.4444 16C28.4444 22.9333 22.9333 28.4444 16 28.4444C9.06667 28.4444 3.55556 22.9333 3.55556 16C3.55556 9.06667 9.06667 3.55556 16 3.55556Z" fill="white" />
                                </svg>
                            </div>

                            <div className="pl-4">
                                <h5 className="mb-1">Completed Projects</h5>
                                <h2 className="text-white">{projectsData && projectsData.count && projectsData.count.completecount}</h2>
                            </div>

                        </div>

                        <div className="hidden sm:flex sm:flex-col md:hidden justify-center items-center">
                            <h5 className="mb-1 truncate">Completed Projects</h5>
                            <h2 className="text-white">{projectsData && projectsData.count && projectsData.count.completecount}</h2>
                        </div>

                        <div className="block sm:hidden md:block absolute right-5 bottom-5 mb-2 cursor-pointer">

                            <svg width="21" height="16" viewBox="0 0 21 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <g opacity="0.6">
                                    <path d="M18 8H1" stroke="white" strokeWidth="2" strokeLinecap="round" />
                                    <path d="M13.2549 1.81543L19.0784 8.02495L13.2549 14.2345" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                </g>
                            </svg>
                        </div>

                    </div>
                </div>
            </div>

            <HeaderStrip projectsData={projectsData} page="projectPage" searchSelect={searchSelect} projectListData={projectListData} filterDate={filterDate} getStatus={getStatus} handleChange={handleChange} dataStatus={dataStatus} projectSearch={projectSearch} />

            <div className="px-6 max-w-full overflow-x-scroll">
                <div className="bg-white rounded flex flex-col min-w-[768px]">

                    <header className="border-b">
                        <div className="flex items-center py-3 px-3">
                            {headerTitle && screenWidth <= 768 ?
                                headerTitle.filter(item => item.label !== "Technology")
                                    .map((item) =>
                                        <div key={item.id} className={`text-sm pl-2 text-primary-400 basis-${item.classwidth} ${item.center} first:px-0`}>
                                            {item.label}
                                        </div>
                                    )
                                :
                                headerTitle.map((item) =>
                                    <div key={item.id} className={`text-sm pl-2 text-primary-400 basis-${item.classwidth} ${item.center} first:px-0`}>
                                        {item.label}
                                    </div>
                                )
                            }
                        </div>
                    </header>

                    <div className="">
                        {/* Project listing */}
                        {!loading && projectListData?.length > 0 ?
                            projectListData.map((item, index) =>
                                <Link to={`/projects/${item.name}`} key={index} className="flex items-center justify-between py-3 hover:bg-primary-light transition duration-150 ease-out px-3 border-b">

                                    <div className="flex flex-col justify-start basis-1/3 break-all pr-3">
                                        <div style={{ wordBreak: 'break-word' }} className="mb-1 text-title text-xs sm:text-[13px] font-normal flex items-start">
                                            {item.name}
                                        </div>
                                    </div>

                                    <div className="flex justify-start text-xs sm:text-[13px] text-title capitalize basis-1/4 break-all"> {item.platform === 'web' ? 'Web App' : 'Mobile App'}</div>
                                    <div className="hidden md:block text-xs mr-2 sm:text-[13px] text-title basis-1/2 ">

                                        {item.technologies?.client?.length > 0 ? item.technologies.client.map((frontEnd, index) =>
                                            <div key={index} className="inline-block text-[10px] sm:text-xs">
                                                {frontEnd.status ?
                                                    <span className="items-center p-1 px-2  mr-1 bg-white border border-gray-200 rounded bg-secondary-grey-200 inline-block my-1">
                                                        {frontEnd.techId?.name}{index < item.technologies.client.length - 1 ? " " : ""}
                                                    </span>
                                                    : null}
                                            </div>
                                        ) : ""}


                                        {item.technologies?.server?.length > 0 ? item.technologies.server.map((backEnd, index) =>
                                            <div key={index} className="inline-block text-xs sm:text-[16px]">
                                                {backEnd.status ?
                                                    <span className="items-center p-1 px-2 mr-1 bg-white rounded text-white bg-secondary-grey-200 inline-block my-1">{backEnd.techId?.name}{index < item.technologies.server.length - 1 ? " " : ""}</span>
                                                    : null}
                                            </div>
                                        ) : ""}

                                    </div>

                                    <div className="flex justify-start text-xs sm:text-[13px] text-title basis-1/3 break-all">
                                        {item.client ? item.client.name : "-"}
                                    </div>

                                    <div className="flex justify-start text-xs sm:text-[13px] text-title  basis-1/2 break-all">
                                        <span className="mr-2">{item.start_date ? moment(item.start_date).format('ll') : "-"}</span>
                                        -
                                        <span className="ml-2">{item.end_date ? moment(item.end_date).format('ll') : "Present"}</span>
                                    </div>

                                    <div className="flex text-sm text-title basis-1/5 break-all justify-center">
                                        <span className="font-title flex items-center bg-primary-navyBlue text-white text-xs transition duration-300 ease-out hover:bg-opacity-80 h-7 px-2 rounded-md">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24"><path d="M15 12c0 1.654-1.346 3-3 3s-3-1.346-3-3 1.346-3 3-3 3 1.346 3 3zm9-.449s-4.252 8.449-11.985 8.449c-7.18 0-12.015-8.449-12.015-8.449s4.446-7.551 12.015-7.551c7.694 0 11.985 7.551 11.985 7.551zm-7 .449c0-2.757-2.243-5-5-5s-5 2.243-5 5 2.243 5 5 5 5-2.243 5-5z" fill="#fff" /></svg>
                                        </span>
                                    </div>

                                </Link>
                            )
                            :
                            <div className="flex justify-center items-center min-h-500">
                                <p className="text-sm text-title">{`${loading ? 'Loading...' : 'No data'}`}</p>
                            </div>
                        }
                    </div>
                </div>

                {/* Pagination */}
                {projectsData && projectsData.count && projectsData.count.totalcount && projectsData.count.totalcount > 10 && <Pagination handlePageClick={handlePageClick} pageCount={pageCount} pageLimit={pageLimit} currentPage={currentPage} />}
            </div>
        </>
    );
}

export default Project